<section class="mapfre-card-container {{ additionalSectionClasses }}"
  [ngClass]="{'center-on-page': singleCard }">
  <div class="card mapfre {{additionalClasses}}"
  [ngClass]="{'single-page-card': singleCard,'is-not-Acmic': !isAcmic }">
    <div class="card-content {{ additionalCardContentClasses }}">
      <ng-content></ng-content>
    </div>
  </div>
  <ng-content select=".createCommAccount"></ng-content>
</section>
